import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewsItem } from "@ha/data/basic";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";

import { HomeSelectors } from "../../state/home.selectors";

@UntilDestroy()
@Component({
    selector: "home-news",
    templateUrl: "./home-news.component.html",
    styleUrls: ["home-news.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeNewsComponent {
    @Select(HomeSelectors.newsItems)
    public newsItems$: Observable<NewsItem[]>;
}
